/*=========================================================================================
  File Name: state.js
  Namespace: iframes
  Description: Vuex Store - IFrame state
==========================================================================================*/

export const buildIFrameState = () => {
  return {
    id: null,
    name: '',
    slug: null,
    created: null,
    modified: null,
    type: 'slides',
    metadata: {
      slides_count: 0
    },
    url: null,
    files: [],
    duration_in_seconds: 0,
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  currentIFrame: buildIFrameState(),
  iframeList: null,
  count: 0,
  next: null,
  previous: null,
  results: [],
  currentIFrameFiles: []
}

export default state